export const handleFirstTabInput = () => {
  function handleFirstTab(e: KeyboardEvent) {
    if (e.key === "Tab") {
      document.body.classList.add("user-is-tabbing");
      window.removeEventListener("keydown", handleFirstTab);
    }
  }
  window.addEventListener("keydown", handleFirstTab);
};
